import { type ComponentPropsWithoutRef, forwardRef } from "react";
import { cn } from "../../styles/utils";
import { commonStyles, variantStyles } from "./textFieldStyles";

// import { textStyles } from "~/styles/typography";

type Props = {
  variant?: keyof typeof variantStyles;
  error?: string;
} & ComponentPropsWithoutRef<"input">;

const TextField = forwardRef<HTMLInputElement, Props>(function TextField(
  { variant = "light", className, error, ...props },
  ref,
) {
  return (
    <div className="w-full">
      <input
        {...props}
        ref={ref}
        className={cn(
          // textStyles.sub2,
          commonStyles,
          props.disabled
            ? variantStyles[variant].disabled
            : variantStyles[variant].enabled,
          className,
          error && "border-red",
        )}
      />
      {error && <p className="text-red text-xs mt-1 px-3">{error}</p>}
    </div>
  );
});

export default TextField;
